@if (cardAccount$ | async; as cadAccount) {
  <ng-container *ngTemplateOutlet="cardAccountPage; context: { $implicit: cadAccount, loading: false }"></ng-container>
} @else {
  <ng-container *ngTemplateOutlet="cardAccountPage; context: { $implicit: null, loading: true }"></ng-container>
}

<ng-template #cardAccountPage [appTemplateContext]="cardAccountPageContext" let-cardAccount let-loading="loading">
  <div class="entity-details-container card-account-details-page">
    <div class="entity-details-header">
      <div class="entity-details-title">Card Financial Account Details</div>
    </div>

    <div class="details-row">
      <app-details-item
        [class]="pageClassPrefix + 'name'"
        [showPlaceholder]="loading"
        label="Financial Account Name"
        [value]="$safeNavigationMigration(cardAccount?.name)"
      ></app-details-item>

      <app-details-item
        [class]="pageClassPrefix + 'id'"
        [showPlaceholder]="loading"
        label="Financial Account ID"
        [title]="$safeNavigationMigration(cardAccount?.id) | uppercase"
        [value]="cardAccount?.id || '' | rktShortId"
      ></app-details-item>

      <app-details-item
        [class]="pageClassPrefix + 'category'"
        [showPlaceholder]="loading"
        label="Account Category"
        [value]="$safeNavigationMigration(cardAccount?.category)"
      ></app-details-item>
    </div>

    <div class="financial-account-fields">
      <button
        rktButton
        btnType="link"
        (click)="onCardReissueClick(cardAccount.id)"
        title="Reissue Card"
        [disabled]="!!(loading | accessControl | async)"
        class="reissue-btn"
      >
        <rkt-icon name="plus"></rkt-icon>
        Reissue Card
      </button>

      <div class="financial-account-fields-type">
        <div class="icon">
          @if (loading) {
            <div class="loading-placeholder dark-bg"></div>
          }
          @if (!loading) {
            <rkt-icon name="card"></rkt-icon>
          }
        </div>
        <app-text-with-placeholder [showPlaceholder]="loading" [darkBg]="true">{{ cardAccount?.type }}</app-text-with-placeholder>
      </div>

      <div class="details-row">
        <app-details-item
          [class]="pageClassPrefix + 'name-on-card'"
          [showPlaceholder]="loading"
          label="Name on Card"
          [isDarkBg]="true"
          [value]="$safeNavigationMigration(cardAccount?.card?.fullNameOnCard)"
        ></app-details-item>

        <app-details-item
          [class]="pageClassPrefix + 'card-number'"
          [showPlaceholder]="loading"
          label="Card Number"
          [isDarkBg]="true"
          [value]="'**** ' + $safeNavigationMigration(cardAccount?.card?.cardNumberTail)"
        ></app-details-item>

        <app-details-item
          [class]="pageClassPrefix + 'expiry'"
          [showPlaceholder]="loading"
          label="Card Exp. Date"
          [isDarkBg]="true"
          [value]="$safeNavigationMigration(cardAccount?.card?.expiry)"
        ></app-details-item>

        <app-details-item
          [class]="pageClassPrefix + 'card-interface'"
          [showPlaceholder]="loading"
          label="Card Interface"
          [isDarkBg]="true"
          [value]="$safeNavigationMigration(cardAccount?.cardProviderDetails?.cardInterface) | titlecase"
        ></app-details-item>

        <app-details-item
          [class]="pageClassPrefix + ' card-issue-type'"
          [showPlaceholder]="loading"
          label=" Card Issue Type"
          [isDarkBg]="true"
          [value]="$safeNavigationMigration(cardAccount?.cardProviderDetails?.cardIssueType) | titlecase"
        ></app-details-item>

        <app-details-item
          [class]="pageClassPrefix + 'address'"
          [showPlaceholder]="loading"
          label="Address"
          [isDarkBg]="true"
          [value]="$safeNavigationMigration(cardAccount?.card?.billingAddress?.addressLine1)"
        >
          @if (cardAccount?.card?.billingAddress?.addressLine1) {
            <div>{{ cardAccount?.card?.billingAddress?.addressLine2 }}</div>
            <div>{{ cardAccount?.card?.billingAddress?.city }}, {{ cardAccount?.card?.billingAddress?.state }}</div>
            <div>{{ cardAccount?.card?.billingAddress?.postalCode }} {{ cardAccount?.card?.billingAddress?.country }}</div>
          }
        </app-details-item>
      </div>
    </div>

    <div class="details-row">
      <app-details-item
        [class]="pageClassPrefix + 'card-status'"
        [showPlaceholder]="loading"
        label="Card Status"
        [value]="$safeNavigationMigration(cardAccount?.cardProviderDetails?.cardStatusLabel)"
      ></app-details-item>

      <app-details-item
        [class]="pageClassPrefix + 'card-solution'"
        [showPlaceholder]="loading"
        label="Card Solution"
        [value]="$safeNavigationMigration(cardAccount?.cardProviderDetails?.solution)"
      ></app-details-item>

      <app-details-item
        [class]="pageClassPrefix + 'card-starting-numbers'"
        [showPlaceholder]="loading"
        label="Card Starting Numbers"
        [value]="$safeNavigationMigration(cardAccount?.cardProviderDetails?.startingNumbers)"
      ></app-details-item>

      <app-details-item
        [class]="pageClassPrefix + 'card-program'"
        [showPlaceholder]="loading"
        label="Card Product"
        [value]="$safeNavigationMigration(cardAccount?.cardProviderDetails?.productName)"
      ></app-details-item>

      <app-details-item
        [class]="pageClassPrefix + 'shipping-method'"
        [showPlaceholder]="loading"
        label="Shipping Method"
        [value]="$safeNavigationMigration(cardAccount?.cardProviderDetails?.shippingMethodLabel)"
      ></app-details-item>

      <app-details-item
        [class]="pageClassPrefix + 'extra-embossing-line'"
        [showPlaceholder]="loading"
        label="Extra Embossing Line"
        [value]="$safeNavigationMigration(cardAccount?.cardProviderDetails?.extraEmbossingLine)"
      ></app-details-item>

      <app-details-item
        [class]="pageClassPrefix + 'referral-source'"
        [showPlaceholder]="loading"
        label="Referral Source"
        [value]="$safeNavigationMigration(cardAccount?.cardProviderDetails?.referralSource)"
      ></app-details-item>

      <app-details-item
        [class]="pageClassPrefix + 'issued-language-code'"
        [showPlaceholder]="loading"
        label="Issued Language Code"
        [value]="$safeNavigationMigration(cardAccount?.cardProviderDetails?.issuedLanguageName)"
      ></app-details-item>
    </div>

    <div class="details-separator"></div>

    <div class="details-row details-row-with-offset">
      <app-details-item
        [class]="pageClassPrefix + 'accepted-terms-date'"
        [showPlaceholder]="loading"
        label="Accepted Terms Date"
        [value]="$safeNavigationMigration(cardAccount?.cardProviderDetails?.acceptedTermsDate) | dateFormat: 'MM/dd/yy' : 'ISO'"
      ></app-details-item>
    </div>

    @if (cardAccount?.cardProviderDetails?.reissueReason) {
      <div class="details-separator"></div>
      <div class="details-row details-row-with-offset">
        <app-details-item
          [class]="pageClassPrefix + 'reissue-date'"
          [showPlaceholder]="loading"
          label="Reissued Date"
          [value]="$safeNavigationMigration(cardAccount?.cardProviderDetails?.reissueDateTime) | dateFormat"
        ></app-details-item>
        <app-details-item
          [class]="pageClassPrefix + 'reissue-reason'"
          [showPlaceholder]="loading"
          label="Reissued Reason"
          [value]="$safeNavigationMigration(cardAccount?.cardProviderDetails?.reissueReasonLabel)"
        ></app-details-item>
        <app-details-item
          [class]="pageClassPrefix + 'reissue-type'"
          [showPlaceholder]="loading"
          label="Reissued Type"
          [value]="$safeNavigationMigration(cardAccount?.cardProviderDetails?.reissueTypeLabel)"
        ></app-details-item>
      </div>
    }

    <div class="details-separator"></div>

    <div class="details-row details-row-with-offset">
      <app-details-item
        [class]="pageClassPrefix + 'created-at'"
        [showPlaceholder]="loading"
        label="Created At"
        [value]="$safeNavigationMigration(cardAccount?.createdAt) | dateFormat"
      ></app-details-item>

      <app-details-item
        [class]="pageClassPrefix + 'created-by'"
        [showPlaceholder]="loading"
        label="Created By"
        [value]="$safeNavigationMigration(cardAccount?.createdBy?.id) | teamMemberName | async"
      ></app-details-item>
    </div>

    <div class="details-row">
      <app-details-item
        [class]="pageClassPrefix + 'updated-at'"
        [showPlaceholder]="loading"
        label="Updated At"
        [value]="$safeNavigationMigration(cardAccount?.updatedAt) | dateFormat"
      ></app-details-item>

      <app-details-item
        [class]="pageClassPrefix + 'updated-by'"
        [showPlaceholder]="loading"
        label="Updated By"
        [value]="$safeNavigationMigration(cardAccount?.updatedBy?.id) | teamMemberName | async"
      ></app-details-item>
    </div>

    @if (cardAccount?.id) {
      <app-details-notes entityType="FINANCIAL_ACCOUNT" [entityId]="cardAccount.id"></app-details-notes>
    }
  </div>
</ng-template>
